jQuery(document).ready(() => {
  const imgSideSlider = $(".img-side-slider");
  imgSideSlider.slick({
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    variableWidth: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          variableWidth: false,
        },
      },
      {
        breakpoint: 320,
        settings: {
          variableWidth: false,
        },
      },
    ],
  });
});



// WEBPACK FOOTER //
// ./scripts/modules/sliders/img-side-slider.js